module.exports = __webpack_public_path__ + "img/2_2.60b40c18.jpg";